import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { commonStyles } from '../../styles/styles';
import PropTypes from 'prop-types';
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon, MDBModalFooter } from 'mdbreact';
const renderText = ({ classes, meta, registrationForm, input, label }) => {
  const conditionError = meta.error && meta.touched;
  return (
    <FormControl
      className={`${classes.formField} ${registrationForm ? classes.regField : false}`}
      aria-describedby="name-error-text"
      error={conditionError}
    >
      {console.log('MANAGERERROR', meta)}
      <MDBInput
        {...input}
        name={input.name}
        type="Text"
        label={label}
        error={conditionError}
        className={`${classes.formInput} ${conditionError ? classes.inputError : false}`}
        disableUnderline
        classes={{ focused: classes.formInputFocus }}
      />
      {conditionError && (
        <FormHelperText id="name-error-text" className={classes.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

const styles = () => ({
  ...commonStyles,
});

export default compose(withStyles(styles))(renderText);



// WEBPACK FOOTER //
// ./src/Components/Form/TextField.jsx